import { getConfigWithMetadata } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import { type TextToFilterParams, type AiTextToFilterRequest, type AiTextToFilterResponse } from '@generated/search-bff/index';
import { textToFilter as generatedGetFilterByAiPrompt } from '@generated/search-bff/controllers/ai/ai';

/**
 * Converts a text to a search filter using the `/api/v1/ai/text-to-filter` endpoint.
 *
 * `marketCountryCode` is sent as a query parameter so the BFF can resolve locations for the active market.
 */
export async function getFilterByAiPrompt(
  { marketCountryCode, ...aiTextToFilterRequest }: AiTextToFilterRequest & TextToFilterParams,
  apiConfig: ApiConfig,
): Promise<ApiResult<AiTextToFilterResponse>> {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, 'getFilterByAiPrompt');
    const data = await generatedGetFilterByAiPrompt(aiTextToFilterRequest, { marketCountryCode }, _apiConfig);

    return {
      status: 'success',
      data,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
